import { DEFAULT_ADMIN_PWA_PAGE_ID, DEFAULT_ADMIN_PWA_PAGE_NAME } from 'src/common/constants/pages';
import loadable from '@loadable/component';
export class PwaController {
  constructor() {
    this.bundles = ['pwa'];
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "pwa";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: () => import( /* webpackChunkName: "pwa" */'views/admin/pwa'),
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("views/admin/pwa");
        }
        return eval('require.resolve')("views/admin/pwa");
      }
    });
    this.pageId = DEFAULT_ADMIN_PWA_PAGE_ID;
    this.path = '/pwa';
    this.exact = true;
    this.routeName = 'pwa';
    this.routeData = {
      rfrrNamespace: 'PWA.ADMIN',
      pageName: DEFAULT_ADMIN_PWA_PAGE_NAME
    };
  }
  fetch() {
    return Promise.resolve();
  }
  fetchPageData() {
    return Promise.resolve({
      seo: {
        robots: 'noindex'
      }
    });
  }
}